import { trimSlashes } from './trimSlashes';

export const joinWithSlashes = (...parts: string[]) => {
  return parts
    .map(trimSlashes)
    .filter((part) => part !== '')
    .join('/');
};
